import React, { useEffect } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Divider, Grid, TextField, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { createSetting, updateSetting } from '../../../store/settingSlice';
import CommentDrawer from '../../Common/Drawer';

export default function GlobalSettingForm({ page, setPage, fetchSetting, title, openModal, setOpenModal, resetTrigger, selectedSetting = null }) {
    const dispatch = useDispatch()
    const [isButtonDisabled, setIsButtonDisabled] = React.useState();

    const validationSchema = Yup.object({
        key: Yup.string()
            .required("Key is required"),
        value: Yup.string()
            .min(1).max(300, "Value should not be greater then 300 character")
            .required("Value is required")
    });

    const formik = useFormik({
        initialValues: {
            key: "",
            value: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            console.log("Form Submitted:", values);
            setOpenModal(false)
            if (selectedSetting) {
                values.id = selectedSetting.uuid
                dispatch(updateSetting(values)).then(() => {
                    fetchSetting()
                })
            } else {
                dispatch(createSetting(values)).then(() => {
                    if (page > 0) {
                        setPage(0)
                    } else {
                        fetchSetting()
                    }
                })
            }
        },
    });

    const handleClose = () => {
        setOpenModal(false);
    };

    useEffect(() => {
        if (selectedSetting?.key && openModal) {
            formik.setFieldValue("key", selectedSetting.key);
            formik.setFieldValue("value", selectedSetting.value);
        } else {
            formik.resetForm()
        }
    }, [selectedSetting, openModal, resetTrigger])

    useEffect(() => {
        if (selectedSetting) {
            const disabled = JSON.stringify({
                "key": formik.values.key,
                "value": formik.values.value
            }) === JSON.stringify({
                "key": selectedSetting.key,
                "value": selectedSetting.value
            });
            setIsButtonDisabled(disabled)
        }

    }, [selectedSetting, formik.values])


    return (
        // <Dialog
        //     open={openModal}
        //     onClose={() => { setOpenModal(false) }}
        //     aria-labelledby="alert-dialog-title"
        //     aria-describedby="alert-dialog-description"
        // >
        //     <DialogContent>
        <CommentDrawer open={openModal} setOpen={setOpenModal} >
            <Grid size={{ lg: 3, md: 6, sm: 12, xs: 12 }} className="p-3">
                <Box
                    component="form"
                    onSubmit={formik.handleSubmit}
                >
                    <Typography variant="h6" gutterBottom>
                        {title}
                    </Typography>
                    <Divider />
                    <div className='role-form-scroller'>
                        <TextField
                            fullWidth
                            required
                            id="key"
                            name="key"
                            label="Key"
                            margin="normal"
                            variant="outlined"
                            slotProps={{
                                input: {
                                    readOnly: true,
                                },
                            }}
                            value={formik.values.key}
                            disabled={true}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.key && Boolean(formik.errors.key)}
                            helperText={formik.touched.key && formik.errors.key}
                        />
                        <TextField
                            fullWidth
                            required
                            multiline
                            rows={3}
                            id="value"
                            name="value"
                            label="Value"
                            margin="normal"
                            variant="outlined"
                            value={formik.values.value}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.value && Boolean(formik.errors.value)}
                            helperText={formik.touched.value && formik.errors.value}
                        />
                    </div>
                    <Box className="drawer-footer m-3">
                        <Button
                            type="button"
                            variant="outlined"
                            color="primary"
                            onClick={handleClose}
                            className="mt-2 mr-2"
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className="mt-2"
                            disabled={selectedSetting ? (isButtonDisabled || !formik.isValid) : !(formik.dirty && formik.isValid)}
                        >
                            Save
                        </Button>
                    </Box>
                </Box>
            </Grid>
        </CommentDrawer>
        //     {/* </DialogContent>
        // </Dialog> */}
    );
}